import { pathJoin } from 'src/reducers/routing/utils'

export const createCollectionDeviationDetailViewRoutesMap = (
  prefix: string
) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  periods: pathJoin(prefix)('periods').chain,
})
